import ValidationType from '../ValidationType';

class ResponseRequired extends ValidationType {
  get required() {
    return true;
  }

  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (fieldResponse.isEmpty) {
      errors.push({
        fieldResponse: fieldResponse,
        key: "ERROR_FIELD_REQUIRED",
        message: "This field is required",
      });
    }
    return errors;
  }

}

export default ResponseRequired;
